import './FormStatus.scss'

const FormStatus = ({status}) => {
    return status && <div id="form-status">{status}</div>
}
export default FormStatus